export const TYPES = {
  FILTER_RECENTLY_MODIFIED: "FILTER_RECENTLY_MODIFIED",
};

export function filterRecentlyModified(filter) {
  return {
    type: TYPES.FILTER_RECENTLY_MODIFIED,
    filter,
  };
}
